
import Vue from 'vue'
export default Vue.extend({
  name: 'legalInfoPanel',
  props: {
    title: {
      default: ''
    },
    haveChanges: {
      default: false
    },
    necessaryBefore: {
      default: ''
    },
    loadingChanges: {
      default: false
    },
    opened: {
      default: false
    },
    sectionHeight: {
      type: Number,
      required: true
    },
    itBuddy: {
      default: false
    }
  },
  data: () => ({
    openedPanel: false
  }),
  mounted () {
    if (this.opened) {
      this.openedPanel = 0
    } else {
      this.openedPanel = undefined
    }
  },
  watch: {
    opened (value: boolean) {
      if (value) {
        this.openedPanel = 0
      } else {
        this.openedPanel = undefined
      }
    },
    openedPanel (value: undefined | number) {
      if (value === 0) {
        this.$emit('onChange')
      }
    }
  }
})
